export const rewardABI = [
  { inputs: [], name: 'AccessControlBadConfirmation', type: 'error' },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'bytes32', name: 'neededRole', type: 'bytes32' },
    ],
    name: 'AccessControlUnauthorizedAccount',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'address', name: 'target', type: 'address' }],
    name: 'AddressEmptyCode',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'AddressInsufficientBalance',
    type: 'error',
  },
  { inputs: [], name: 'CheckpointUnorderedInsertion', type: 'error' },
  {
    inputs: [
      { internalType: 'uint256', name: 'timepoint', type: 'uint256' },
      { internalType: 'uint32', name: 'clock', type: 'uint32' },
    ],
    name: 'ERC5805FutureLookup',
    type: 'error',
  },
  { inputs: [], name: 'FailedInnerCall', type: 'error' },
  { inputs: [], name: 'InvalidInitialization', type: 'error' },
  { inputs: [], name: 'NotGovError', type: 'error' },
  { inputs: [], name: 'NotInitializing', type: 'error' },
  { inputs: [], name: 'NotOwnerError', type: 'error' },
  {
    inputs: [
      { internalType: 'uint8', name: 'bits', type: 'uint8' },
      { internalType: 'uint256', name: 'value', type: 'uint256' },
    ],
    name: 'SafeCastOverflowedUintDowncast',
    type: 'error',
  },
  {
    inputs: [{ internalType: 'address', name: 'token', type: 'address' }],
    name: 'SafeERC20FailedOperation',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'nftId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'total',
        type: 'uint256',
      },
    ],
    name: 'DatasetRewardsClaimed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint64',
        name: 'version',
        type: 'uint64',
      },
    ],
    name: 'Initialized',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'uint32', name: 'pos', type: 'uint32' },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'agentCount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'totalStaked',
        type: 'uint256',
      },
    ],
    name: 'NewMainReward',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'shares',
        type: 'uint256',
      },
    ],
    name: 'ParentSharesUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'rewardToken',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'agentNft',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'contributionNft',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'serviceNft',
        type: 'address',
      },
    ],
    name: 'RefContractsUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint16',
        name: 'protocolShares',
        type: 'uint16',
      },
      {
        indexed: false,
        internalType: 'uint16',
        name: 'contributorShares',
        type: 'uint16',
      },
      {
        indexed: false,
        internalType: 'uint16',
        name: 'stakerShares',
        type: 'uint16',
      },
      {
        indexed: false,
        internalType: 'uint16',
        name: 'parentShares',
        type: 'uint16',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'stakeThreshold',
        type: 'uint256',
      },
    ],
    name: 'RewardSettingsUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'previousAdminRole',
        type: 'bytes32',
      },
      {
        indexed: true,
        internalType: 'bytes32',
        name: 'newAdminRole',
        type: 'bytes32',
      },
    ],
    name: 'RoleAdminChanged',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
    ],
    name: 'RoleGranted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'sender',
        type: 'address',
      },
    ],
    name: 'RoleRevoked',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'nftId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'total',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'childrenAmount',
        type: 'uint256',
      },
    ],
    name: 'ServiceRewardsClaimed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'threshold',
        type: 'uint256',
      },
    ],
    name: 'StakeThresholdUpdated',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'virtualId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'staker',
        type: 'address',
      },
    ],
    name: 'StakerRewardClaimed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'by', type: 'address' },
      {
        indexed: true,
        internalType: 'address',
        name: 'receiver',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'TokenSaved',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'virtualId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'validator',
        type: 'address',
      },
    ],
    name: 'ValidatorRewardClaimed',
    type: 'event',
  },
  {
    inputs: [],
    name: 'DEFAULT_ADMIN_ROLE',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'DENOMINATOR',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'GOV_ROLE',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'TOKEN_SAVER_ROLE',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'nftId', type: 'uint256' }],
    name: '_claimServiceRewards',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'nftId', type: 'uint256' }],
    name: '_getClaimableServiceRewards',
    outputs: [{ internalType: 'uint256', name: 'total', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'agentNft',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256[]', name: 'virtualIds', type: 'uint256[]' },
      {
        internalType: 'uint256[]',
        name: 'contributionNftIds',
        type: 'uint256[]',
      },
    ],
    name: 'claimAllRewards',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'contributionNft',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'amount', type: 'uint256' }],
    name: 'distributeRewards',
    outputs: [{ internalType: 'uint32', name: '', type: 'uint32' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'nftId', type: 'uint256' }],
    name: 'getChildrenRewards',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint32', name: 'pos', type: 'uint32' }],
    name: 'getMainReward',
    outputs: [
      {
        components: [
          { internalType: 'uint32', name: 'blockNumber', type: 'uint32' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
          { internalType: 'uint256', name: 'agentCount', type: 'uint256' },
          { internalType: 'uint256', name: 'totalStaked', type: 'uint256' },
        ],
        internalType: 'struct IAgentReward.MainReward',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint32', name: 'timepoint', type: 'uint32' }],
    name: 'getPastRewardSettings',
    outputs: [
      {
        components: [
          { internalType: 'uint16', name: 'protocolShares', type: 'uint16' },
          { internalType: 'uint16', name: 'contributorShares', type: 'uint16' },
          { internalType: 'uint16', name: 'stakerShares', type: 'uint16' },
          { internalType: 'uint16', name: 'parentShares', type: 'uint16' },
          { internalType: 'uint256', name: 'stakeThreshold', type: 'uint256' },
        ],
        internalType: 'struct RewardSettingsCheckpoints.RewardSettings',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'virtualId', type: 'uint256' },
      { internalType: 'uint32', name: 'pos', type: 'uint32' },
    ],
    name: 'getReward',
    outputs: [
      {
        components: [
          { internalType: 'uint48', name: 'id', type: 'uint48' },
          { internalType: 'uint32', name: 'mainIndex', type: 'uint32' },
          { internalType: 'uint256', name: 'totalStaked', type: 'uint256' },
          { internalType: 'uint256', name: 'validatorAmount', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'contributorAmount',
            type: 'uint256',
          },
          { internalType: 'uint256', name: 'coreAmount', type: 'uint256' },
        ],
        internalType: 'struct IAgentReward.Reward',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getRewardSettings',
    outputs: [
      {
        components: [
          { internalType: 'uint16', name: 'protocolShares', type: 'uint16' },
          { internalType: 'uint16', name: 'contributorShares', type: 'uint16' },
          { internalType: 'uint16', name: 'stakerShares', type: 'uint16' },
          { internalType: 'uint16', name: 'parentShares', type: 'uint16' },
          { internalType: 'uint256', name: 'stakeThreshold', type: 'uint256' },
        ],
        internalType: 'struct RewardSettingsCheckpoints.RewardSettings',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }],
    name: 'getRoleAdmin',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'virtualId', type: 'uint256' }],
    name: 'getServiceReward',
    outputs: [
      {
        components: [
          { internalType: 'uint256', name: 'impact', type: 'uint256' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
          { internalType: 'uint256', name: 'parentAmount', type: 'uint256' },
          { internalType: 'uint256', name: 'totalClaimed', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'totalClaimedParent',
            type: 'uint256',
          },
        ],
        internalType: 'struct IAgentReward.ServiceReward',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'uint256[]', name: 'virtualIds', type: 'uint256[]' },
      {
        internalType: 'uint256[]',
        name: 'contributionNftIds',
        type: 'uint256[]',
      },
    ],
    name: 'getTotalClaimableRewards',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes32', name: 'role', type: 'bytes32' },
      { internalType: 'address', name: 'account', type: 'address' },
    ],
    name: 'grantRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes32', name: 'role', type: 'bytes32' },
      { internalType: 'address', name: 'account', type: 'address' },
    ],
    name: 'hasRole',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'rewardToken_', type: 'address' },
      { internalType: 'address', name: 'agentNft_', type: 'address' },
      { internalType: 'address', name: 'contributionNft_', type: 'address' },
      { internalType: 'address', name: 'serviceNft_', type: 'address' },
      {
        components: [
          { internalType: 'uint16', name: 'protocolShares', type: 'uint16' },
          { internalType: 'uint16', name: 'contributorShares', type: 'uint16' },
          { internalType: 'uint16', name: 'stakerShares', type: 'uint16' },
          { internalType: 'uint16', name: 'parentShares', type: 'uint16' },
          { internalType: 'uint256', name: 'stakeThreshold', type: 'uint256' },
        ],
        internalType: 'struct RewardSettingsCheckpoints.RewardSettings',
        name: 'settings_',
        type: 'tuple',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'protocolRewards',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes32', name: 'role', type: 'bytes32' },
      { internalType: 'address', name: 'callerConfirmation', type: 'address' },
    ],
    name: 'renounceRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes32', name: 'role', type: 'bytes32' },
      { internalType: 'address', name: 'account', type: 'address' },
    ],
    name: 'revokeRole',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'virtualId', type: 'uint256' }],
    name: 'rewardCount',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'rewardToken',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: '_token', type: 'address' },
      { internalType: 'address', name: '_receiver', type: 'address' },
      { internalType: 'uint256', name: '_amount', type: 'uint256' },
    ],
    name: 'saveToken',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'serviceNft',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint16', name: 'protocolShares_', type: 'uint16' },
      { internalType: 'uint16', name: 'contributorShares_', type: 'uint16' },
      { internalType: 'uint16', name: 'stakerShares_', type: 'uint16' },
      { internalType: 'uint16', name: 'parentShares_', type: 'uint16' },
      { internalType: 'uint256', name: 'stakeThreshold_', type: 'uint256' },
    ],
    name: 'setRewardSettings',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'rewardToken_', type: 'address' },
      { internalType: 'address', name: 'agentNft_', type: 'address' },
      { internalType: 'address', name: 'contributionNft_', type: 'address' },
      { internalType: 'address', name: 'serviceNft_', type: 'address' },
    ],
    name: 'updateRefContracts',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'validatorPoolRewards',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'recipient', type: 'address' }],
    name: 'withdrawProtocolRewards',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'recipient', type: 'address' }],
    name: 'withdrawValidatorPoolRewards',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;
